"use client";

import { useNavSections } from "@/hooks/useNavSections";
import BaseNavContainer from "./BaseNavContainer";

export default function GailAgentNavContainer({
  children,
  onUserManagementClick,
}: Readonly<{
  children: React.ReactNode;
  onUserManagementClick?: () => void;
}>) {
  const { sections, sideNavMessage } = useNavSections();

  return (
    <BaseNavContainer
      menuSections={sections}
      sideNavMessage={sideNavMessage}
      onUserManagementClick={onUserManagementClick}
    >
      {children}
    </BaseNavContainer>
  );
}
